import React from "react";

const CHECKBOX_CLASSES =
  "appearance-none w-[16px] h-[16px] cursor-pointer rounded-sm border-2 border-gray-300 focus:ring-0 checked:bg-[#FF6700] checked:border-[#FF6700] checked:bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22white%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12.207%204.793a1%201%200%20010%201.414l-5%205a1%201%200%2001-1.414%200l-2-2a1%201%200%20011.414-1.414L6.5%209.086l4.293-4.293a1%201%200%20011.414%200z%22%2F%3E%3C%2Fsvg%3E')] checked:bg-no-repeat checked:bg-center";

interface FilterDropdownPanelProps {
  isOpen: boolean;
  options: string[];
  selectedValues: string[];
  onToggle: (value: string) => void;
  position: { top: number; left: number };
  width?: number;
}

const FilterDropdownPanel: React.FC<FilterDropdownPanelProps> = ({
  isOpen,
  options,
  selectedValues,
  onToggle,
  position,
  width = 180,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`dropdown-panel fixed bg-white border border-gray-200 rounded-lg shadow-lg z-[5] p-3 flex flex-col gap-2 z-[100000] overflow-y-auto overscroll-contain`}
      style={{
        top: position.top,
        left: position.left,
        width: `${width}px`,
        maxHeight: `calc(100dvh - ${position.top}px - 16px)`,
      }}
    >
      {options.map((option) => (
        <label
          key={option}
          className="flex items-center justify-between px-1 py-2 cursor-pointer rounded"
        >
          <span className="text-[12px] md:text-[14px] font-normal text-bfl-blue">{option}</span>
          <input
            type="checkbox"
            checked={selectedValues.includes(option)}
            onChange={() => onToggle(option)}
            className={CHECKBOX_CLASSES}
          />
        </label>
      ))}
    </div>
  );
};

export default FilterDropdownPanel;
